import React from 'react';

import { useCompleteFragment } from '@eluve/apollo-client';
import {
  appointmentReadonlyDataFragment,
  useReassignAppointmentOwner,
} from '@eluve/frontend-appointment-hooks';
import { TenantUserSelector } from '@eluve/smart-blocks';

interface ChangeAppointmentOwnerProps {
  appointmentId: string;
  tenantId: string;
}

export const ChangeAppointmentOwner: React.FC<ChangeAppointmentOwnerProps> = ({
  appointmentId,
  tenantId,
}) => {
  const { userId } = useCompleteFragment({
    fragment: appointmentReadonlyDataFragment,
    key: {
      id: appointmentId,
    },
  });

  const reassignAppointmentOwner = useReassignAppointmentOwner();

  const handleUserSelected = async (newUserId: string) => {
    if (newUserId === userId) {
      return;
    }

    await reassignAppointmentOwner({
      variables: {
        tenantId,
        appointmentId,
        newOwnerId: newUserId,
      },
    });
  };

  return (
    <TenantUserSelector
      selectedUserId={userId}
      tenantId={tenantId}
      onUserSelected={handleUserSelected}
    />
  );
};
